const locale = {
  next:'scheduling_publication_tour.btn_next',
  close:'scheduling_publication_tour.btn_next',
  back:'scheduling_publication_tour.btn_back', 
  last:'scheduling_publication_tour.btn_last',
  skip:'scheduling_publication_tour.btn_skip'
}

export const StarterTurorialSteps =  [
  {
    target: '#social-medias-selector',
    content: 'scheduling_publication_tour.step1',
    disableBeacon:true,
    placement:'right',
    locale,
  },
  {
    target: '#social-medias-image-preview',
    content: 'scheduling_publication_tour.step2',
    disableBeacon:false,
    placement:'left',
    event:'hover',
    spotlightClicks: true,
    styles:{
      beacon:{
        outline:'none',
        left:'240px',
        width:'100px',
        height:'100px'

      }
    },
    locale,
  },
  {
    target: '#social-medias-selector-item',
    content: 'scheduling_publication_tour.step3',
    disableBeacon:true,
    placement:'right',
    locale,
  }
 
]

export const CalendarSteps = [
  {
    target: '#schedule-calendar',
    content: 'scheduling_publication_tour.step4',
    disableBeacon:true,
    placement:'auto',
    locale,
  },
  {
    target: '#time-selector',
    content: 'scheduling_publication_tour.step5',
    disableBeacon:true,
    placement:'auto',
    locale,
  },
  {
    target: '#social-medias-config',
    content: 'scheduling_publication_tour.step6',
    disableBeacon:true,
    placement:'auto',
    locale,
  },
  {
    target: '#final-button',
    content: 'scheduling_publication_tour.step7',
    disableBeacon:true,
    placement:'left',
    locale,
  }
]